import { changeBaseUrl } from './changeBaseUrl';
import { VERTICAL_EMBED_TYPE } from 'wix-rich-content-common';
export function verticalEmbedViewerStrategy(baseUrl, disabled = false) {
    return {
        config: {
            [VERTICAL_EMBED_TYPE]: {
                changeBaseUrl: url => changeBaseUrl(url, baseUrl),
                disabled,
            },
        },
    };
}
//# sourceMappingURL=verticalEmbedViewerStrategy.js.map